import * as React from 'react';
export default /*#__PURE__*/React.memo(function (_ref) {
  var children = _ref.children;
  return children;
}, function (_, _ref2) {
  var visible = _ref2.visible;
  return !visible;
});